import React from 'react'

import PropTypes from 'prop-types'

import { FormControl, FormControlLabel, Switch } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledFormControl = styled(FormControl)(() => ({
  textAlign: 'center',
  justifyContent: 'center',
  margin: '0rem',
}))

const BooleanFilterInput = ({ filter, selectedValues, handleSelectedValues, sx }) => {
  const switchValue = !!selectedValues[filter.field]
  return (
    <StyledFormControl variant="outlined">
      <FormControlLabel
        control={
          <Switch
            color="primary"
            name={filter.field}
            value={switchValue}
            checked={switchValue}
            onChange={(event) => {
              handleSelectedValues(event, { [filter.field]: event.target.checked }, switchValue ? 'clear' : undefined)
            }}
          />
        }
        labelPlacement="top"
        label={filter.headerName}
        sx={sx}
      />
    </StyledFormControl>
  )
}

BooleanFilterInput.propTypes = {
  filter: PropTypes.object,
  selectedValues: PropTypes.object,
  handleSelectedValues: PropTypes.func,
  filterWidthClass: PropTypes.string,
  sx: PropTypes.object,
}

export default BooleanFilterInput
